import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000/api";

export default function Header() {
  const [availableCount, setAvailableCount] = useState(0);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!token) return;
    const fetchCount = async () => {
      try {
        const res = await axios.get(`${API_URL}/creator-claims/available/count`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setAvailableCount(res.data.count);
      } catch (err) {
        console.error("Failed to fetch available count", err);
      }
    };
    fetchCount();
    const interval = setInterval(fetchCount, 30000); // every 30 seconds
    return () => clearInterval(interval);
  }, [token]);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  return (
    <header className="bg-primary text-white shadow-md">
      <div className="container mx-auto px-4 py-4 flex flex-col sm:flex-row justify-between items-center gap-4">
        <Link to="/dashboard" className="text-2xl font-bold">VerSeer Creator Hub</Link>
        <div className="flex flex-wrap gap-3 justify-center items-center">
          <Link to="/dashboard" className="hover:underline">Dashboard</Link>
          <Link to="/available-requests" className="hover:underline relative">
            Available Requests
            {availableCount > 0 && (
              <span className="absolute -top-2 -right-4 bg-red-500 text-white text-xs rounded-full px-1.5 py-0.5 min-w-[18px] text-center">
                {availableCount > 9 ? "9+" : availableCount}
              </span>
            )}
          </Link>
          <Link to="/my-claims" className="hover:underline">My Claims</Link>
          <Link to="/submit" className="hover:underline">Submit Video</Link>
          <Link to="/my-videos" className="hover:underline">My Videos</Link>
          <Link to="/profile" className="hover:underline">Profile</Link>
          <button onClick={handleLogout} className="bg-white text-primary px-3 py-1 rounded-md text-sm font-semibold hover:bg-gray-100 transition">
            Logout
          </button>
        </div>
      </div>
    </header>
  );
}